<template>
  <div class="pa-10">
    <MonitorStudentsDataTable />
  </div>
</template>

<script>
import MonitorStudentsDataTable from "@/components/Utils/MonitorStudentsDataTable.vue";
export default {
  components: {
    MonitorStudentsDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
